/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';

/**
 * 
 * @export
 * @interface ChatRequestContent
 */
export interface ChatRequestContent {
    /**
     * List analytics with particular promptRevisionId
     * @type {Array<Message>}
     * @memberof ChatRequestContent
     */
    messages: Array<Message>;
    /**
     * 
     * @type {string}
     * @memberof ChatRequestContent
     */
    contactImportId?: string;
}


/**
 * Check if a given object implements the ChatRequestContent interface.
 */
export function instanceOfChatRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "messages" in value;

    return isInstance;
}

export function ChatRequestContentFromJSON(json: any): ChatRequestContent {
    return ChatRequestContentFromJSONTyped(json, false);
}

export function ChatRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messages': ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'contactImportId': !exists(json, 'contactImportId') ? undefined : json['contactImportId'],
    };
}

export function ChatRequestContentToJSON(value?: ChatRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messages': ((value.messages as Array<any>).map(MessageToJSON)),
        'contactImportId': value.contactImportId,
    };
}

